import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import {MatGridListModule} from '@angular/material/grid-list';
import { MatSliderModule } from '@angular/material/slider';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { getCookie } from '../../../../utils/getCookies';
import { ModalGeneralComponent } from '../../../user/modals/modal-general/modal-general.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-step-2',
  standalone: true,
  imports: [MatChipsModule, CommonModule, FormsModule, ReactiveFormsModule, MatInputModule, MatSliderModule, MatButtonModule, MatRadioModule, MatGridListModule, TranslateModule],
  templateUrl: './step-2.component.html',
  styleUrl: './step-2.component.scss'
})
export class Step2Component implements OnInit{

  selectedCualitiesDepartment:any = {
    "collaborative": false,
    "empathetic": false,
    "inclusive": false,
    "customerOriented": false,
    "innovative": false,
    "creative": false,
    "adaptable": false,
    "proactive": false,
    "resultsOriented": false,
    "highPerformance": false,
    "processOriented": false,
    "transparent": false,
    "ethical": false,
    "analytical": false,
    "qualityOriented": false,
    "resilience": false,
    "hierarchical": false,
    "bureaucratic": false,
    "promotesWorkLifeBalance": false
}
  habilidadesPersonales: any[] = [
    { name: "Responsabilidad", value: "0" },
    { name: "Proactividad", value: "0" },
    { name: "Gestión del tiempo", value: "0" },
    { name: "Capacidad de aprendizaje", value: "0" },
    { name: "Atención al detalle", value: "0" },
    { name: "Manejo del estrés", value: "0" },
    { name: "Orientación a resultados", value: "0" },
    { name: "Creatividad e innovación", value: "0" },
    { name: "Habilidades analíticas", value: "0" },
    { name: "Trabajo en equipo", value: "0" },
    { name: "Adaptabilidad / Flexibilidad", value: "0" }
  ];

  habilidadesComerciales: any[] = [
    { name: "Habilidades comerciales", value: "0" },
    { name: "Gestión de cuentas/clientes", value: "0" },
    { name: "Orientación al cliente", value: "0" },
    { name: "Negociación", value: "0" }
  ];

  habilidadesComunicacion: any[] = [
    { name: "Capacidad para hablar en público", value: "0" },
    { name: "Habilidades de persuasión positiva", value: "0" }
  ];

  habilidadesLiderazgo: any[] = [
    { name: "Toma de decisiones", value: "0" },
    { name: "Visión estratégica", value: "0" },
    { name: "Resolución de problemas", value: "0" }
  ];

  habilidadesEticas: any[] = [
    { name: "Integridad", value: "0" },
    { name: "Confidencialidad", value: "0" },
  ]

  isLoading = false;
  errorMessage = '';
  selectedCualities: any = {
    "personalManagementSkills": "Habilidades personales",
    "ethicalAndProfessionalSkills": "Habilidades éticas y profesionales",
    "commercialAndClientSkills": "Habilidades comerciales y de atención al cliente",
    "communicationSkills": "Habilidades de comunicación",
    "leadershipSkills": "Habilidades de liderazgo",
    "technicalSkills": "Habilidades técnicas", 

  };

  selectedCualitiesNameOrdered : string[] = ["technicalSkills", "commercialAndClientSkills", "communicationSkills", "ethicalAndProfessionalSkills", "leadershipSkills", "personalManagementSkills"]

  selectedCualities_all: any = {
    "personalManagementSkills": this.habilidadesPersonales,
    "ethicalAndProfessionalSkills": this.habilidadesEticas,
    "commercialAndClientSkills": this.habilidadesComerciales,
    "communicationSkills": this.habilidadesComunicacion,
    "leadershipSkills": this.habilidadesLiderazgo}

  jobOfferForm: FormGroup;

  delete_technicalskills() {
    let val = this.jobOfferForm.get('selectedCualities')?.value;
    val.splice(val.indexOf('technicalSkills'), 1);
    return val;
  }
  
  
    loading = false;

  constructor(private fb: FormBuilder, private route: ActivatedRoute, private router: Router, private http: HttpClient, public dialog: MatDialog, private translate: TranslateService) {

    this.jobOfferForm = this.fb.group({
      offer_id: [""],
      selectedCualities: [[], [Validators.maxLength(3), Validators.minLength(1)]],
      technicalhabilities: [""],
      groupedCualities: this.fb.group({
        personalManagementSkills: this.fb.group(this.habilidadesPersonales.reduce((acc, curr) => {
          acc[curr.name.replace(/\s+/g, "_")] = [""];
          return acc;
        }, {})),
        ethicalAndProfessionalSkills: this.fb.group(this.habilidadesEticas.reduce((acc, curr) => {
          acc[curr.name.replace(/\s+/g, "_")] = [""];
          return acc;
        }, {})),
        commercialAndClientSkills: this.fb.group(this.habilidadesComerciales.reduce((acc, curr) => {
          acc[curr.name.replace(/\s+/g, "_")] = [""];
          return acc;
        }, {})),
        communicationSkills: this.fb.group(this.habilidadesComunicacion.reduce((acc, curr) => {
          acc[curr.name.replace(/\s+/g, "_")] = [""];
          return acc;
        }, {})),
        leadershipSkills: this.fb.group(this.habilidadesLiderazgo.reduce((acc, curr) => {
          acc[curr.name.replace(/\s+/g, "_")] = [""];
          return acc;
        }, {})),
   })
  });
}

  message_saved = '';

transform_name(name: string) {
  return name.replace(/\s+/g, "_");
}

  setOption(skill:string, option: string, value: string) {
    this.jobOfferForm.get('groupedCualities')?.get(skill)?.get(option.replace(/\s+/g, "_"))?.setValue(value);
    // mark as touched
  }

  isselected(skill: string, option: string, value: string) {
    return this.jobOfferForm.get('groupedCualities')?.get(skill)?.get(option.replace(/\s+/g, "_"))?.value === value;
  }

  addcategory(skill: any) {
    if (!this.jobOfferForm.get('selectedCualities')?.value.includes(skill)){
      this.jobOfferForm.get('selectedCualities')?.value.push(skill);

    // we add the control
    for (let key in this.jobOfferForm.get('groupedCualities')?.get(skill)?.value) {

      this.jobOfferForm.get('groupedCualities')?.get(skill)?.get(key)?.setValidators([Validators.required]);

      // we set the errors to initial case when adding a new category
      this.jobOfferForm.get('groupedCualities')?.get(skill)?.get(key)?.setValue("");
      console.log("set value");
      


    }

    }
    else {
      console.log("else");
      this.jobOfferForm.get('selectedCualities')?.value.splice(this.jobOfferForm.get('selectedCualities')?.value.indexOf(skill), 1);
      for (let key in this.jobOfferForm.get('groupedCualities')?.get(skill)?.value) {

      // we reset the values of the selected category
        this.jobOfferForm.get('groupedCualities')?.get(skill)?.get(key)?.setValue('');


        console.log("actual errors ", this.jobOfferForm.get('groupedCualities')?.get(skill)?.get(key)?.errors);
        // we remove the validators
        this.jobOfferForm.get('groupedCualities')?.get(skill)?.get(key)?.setErrors(null);

        // update the untouched value
        this.jobOfferForm.get('groupedCualities')?.get(skill)?.get(key)?.markAsUntouched();

        console.log("errors after reset", this.jobOfferForm.get('groupedCualities')?.get(skill)?.get(key)?.errors);
      }
    }

  }

  ngOnInit() {

    this.route.queryParams.subscribe(params => {
      const offerId = params['offer_id'];
      if (offerId) {
        this.loadJobOffer(offerId);
      }
    });

  }


  

  step = 2;

  goToStep(step: number) {
    this.router.navigate(['/dashboard/company/create-job-offer/step-' + step], { queryParams: { offer_id: this.jobOfferForm.get('offer_id')?.value } });
  } 
  
  goBack() {
    this.router.navigate(['/dashboard/company/create-job-offer/step-' + (this.step - 1)], { queryParams: { offer_id: this.jobOfferForm.get('offer_id')?.value } });
  }



  save_progress(isnext: boolean = false) {
    this.loading = true;
    this.formHasError = false;
    this.nameError = false;
    const accessToken = getCookie('access_token');
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${accessToken}`
        });


    if (this.is_valid_form() || !isnext){
      let data = this.jobOfferForm.value;
  
      this.http.post(environment.url + '/api/v1/jobOfferStep2', data, {headers: headers}).subscribe(
        (data: any) => {
          if (isnext) {
            this.router.navigate(['/dashboard/company/create-job-offer/step-3'], { queryParams: { offer_id: data["joboffer"]["id"] } });
          }
          else{
            this.loading = false;
            this.dialog.open(ModalGeneralComponent, {
              data: {
                title: this.translate.instant('createJobOffer.step2.modals.saved.title'),
                message: this.translate.instant('createJobOffer.step2.modals.saved.message'),
                buttonText: this.translate.instant('createJobOffer.step2.modals.saved.buttonText'),
                type: 'success'
              }
            });
        }
        },
        (error) => {
          console.log(error);
          this.loading = false;
          this.dialog.open(ModalGeneralComponent, {
            data: {
              title: this.translate.instant('createJobOffer.step2.modals.error.title'),
              message: this.translate.instant('createJobOffer.step2.modals.error.message'),
              buttonText: this.translate.instant('createJobOffer.step2.modals.error.buttonText'),
              type: 'error'
            }
          });
        });
    }
    else {

      this.formHasError = true;

      this.dialog.open(ModalGeneralComponent, {
        data: {
          title: this.translate.instant('createJobOffer.step2.modals.invalid.title'),
          message: this.translate.instant('createJobOffer.step2.modals.invalid.message'),
          buttonText: this.translate.instant('createJobOffer.step2.modals.invalid.buttonText'),
          type: 'error'
        }
      });
    }

    this.loading = false;
    
   
  }

  formHasError = false;
  nameError = false;

  is_valid_form(){
    let selectedCualities = this.jobOfferForm.get('selectedCualities')?.value;
    if (selectedCualities.length < 1) {
      return false;
    }
    else{
      for (let key in this.jobOfferForm.get('groupedCualities')?.value) {
        if (selectedCualities.includes(key)) {
          for (let key2 in this.jobOfferForm.get('groupedCualities')?.get(key)?.value) {
            console.log(this.jobOfferForm.get('groupedCualities')?.get(key)?.get(key2)?.value);
            if (this.jobOfferForm.get('groupedCualities')?.get(key)?.get(key2)?.value === '' || this.jobOfferForm.get('groupedCualities')?.get(key)?.get(key2)?.value === "0") {
              this.jobOfferForm.markAllAsTouched();
              return false;
            }
          }
        }
      }
      return true;}

  }



  nextStep() {
    this.save_progress(true);
  }
  status = 0
  loadJobOffer(offerId: number) {
      const accessToken = getCookie('access_token');
          const headers = new HttpHeaders({
              'Authorization': `Bearer ${accessToken}`
          });
  
      this.http.get(environment.url + '/api/v1/getjobOffer', {headers: headers, params: {offer_id: offerId}}).subscribe((data: any) => {
        let offer = data["joboffer"];
        this.status = offer.status;
        if (!offer["selectedCualities"]) {
          offer["selectedCualities"] = [];
        }
        else{

            this.jobOfferForm.patchValue(offer);        }
        
          this.jobOfferForm.get('offer_id')?.setValue(offer.id);
  
      }, (error: any) => {
        console.log(error);
      });
    }



}
